import React from 'react';
import { Icons } from '../../../components/atoms/SVG';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { StatusInfo, StatusInfoModifier } from './partials/StatusInfo';
import { Content } from './partials/Content';
import { Message } from './partials/Message';
import { StatusInfoIcon } from './partials/StatusInfoIcon';

type StatusInfoWarning = {
  message?: string;
  modifier?: StatusInfoModifier;
};

export function StatusInfoWarning({ message, modifier }: StatusInfoWarning) {
  const { t } = useSonTranslation('ErrorInfo');

  return (
    <StatusInfo modifier={modifier}>
      <Content>
        <StatusInfoIcon icon={Icons.FEEDBACK_ERROR} />
        <Message>{message || t('serverError.text')}</Message>
      </Content>
    </StatusInfo>
  );
}
